import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

@Injectable({
  providedIn: 'root',
})
export class BanksService {
  constructor(private restangular: Restangular) {}

  adjustDwollaBalance(userId: string, amount: number, adjustLedger: boolean): Promise<any> {
    return this.restangular.one('dwolla').one('user', userId).one('adjustbalance').customPOST({ amount, adjustLedger }).toPromise();
  }
}
